const affirmReady = new Promise((resolve) => {
  affirm.ui.ready(() => resolve())
});

const intelligemsReady = new Promise((resolve) => {
  if (window.igData) resolve()

  const handleResolve = () => {
    resolve()
    window.removeEventListener('ig:ready', handleResolve)
  }

  window.addEventListener('ig:ready', handleResolve)
})

Promise.all([affirmReady, intelligemsReady]).then(() => {
  document.querySelectorAll('.affirm-as-low-as').forEach((el) => {
    const variantId = parseInt(el.dataset.variantId)
    if (!variantId) return

    let price = window.igData.price.getPriceByVariantId(variantId)
    if (!price) return
    price *= 100

    console.log('Price for variant', price)
    const discount = parseInt(el.dataset.affirmDiscount)
    if (!discount) return

    const newPrice = price - discount
    const currentPrice = parseInt(el.dataset.amount)

    if (newPrice === currentPrice) return

    el.dataset.amount = newPrice
  })

  affirm.ui.refresh()
})